import SubmitSuccessDialog from './components/SubmitSuccessDialog'
import EditInstituteProfileDialog from '../shared/UploadLogoDialog'
import EditIndividuProfileDialog from './components/EditIndividuDialog'

export const ContentMapping = {
  SubmitSuccessDialog,
  EditInstituteProfileDialog,
  EditIndividuProfileDialog,
}
